// extracted by mini-css-extract-plugin
module.exports = {"separator":"footer_separator_1rvze","termsBtn":"footer_termsBtn_1sDyN"};